import gql from 'graphql-tag';
import authFragment from './fragments/authFragment';

export default gql`
  ${authFragment}
  mutation createOAuthMember(
    $provider: oAuthProviders!
    $token: String!
    $cityId: Int
    $promoCode: String
    $termsAndPrivacy: Boolean
    $contactPermission: Boolean
    $additionalPayload: String
    $siteId: Int
    $SignupSource: String
    $SignupMedium: String
    $SignupCampaign: String
  ) {
    oAuthMember: createOAuthMember(
      provider: $provider
      token: $token
      cityId: $cityId
      promoCode: $promoCode
      termsAndPrivacy: $termsAndPrivacy
      contactPermission: $contactPermission
      additionalPayload: $additionalPayload
      siteId: $siteId
      SignupSource: $SignupSource
      SignupMedium: $SignupMedium
      SignupCampaign: $SignupCampaign
    ) {
      ...authFragment
    }
  }
`;
